module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"bulkChange":"Bulk Change","validate":"Validate","contents":"Contents","backlinks":"Backlinks"},"fr":{"bulkChange":"Changement Multiple","validate":"Valider","contents":"Contenus","backlinks":"Backlinks"},"de":{"bulkChange":"Mehrfache Änderung","validate":"Bestätigen","contents":"Inhalt","backlinks":"Backlinks"}}')
  delete Component.options._Ctor
}
